import league from "../../../assets/images/league.jpg";
import feature2Bg from "../../../assets/images/feature_2.png";
import feature3Bg from "../../../assets/images/feature_3.png";
import feature4Bg from "../../../assets/images/feature_4.png";

export interface FeatureCardData {
  id: string;
  title: string;
  description: string;
  backgroundImage: string;
  buttonText?: string;
  buttonRoute?: string;
}

export interface FeatureCardsData {
  features: FeatureCardData[];
}

export const FeatureCardConstants: FeatureCardsData = {
  features: [
    {
      id: "league-manager",
      title: "League Manager",
      description:
        "From fixture generation to automated points tables, manage multi-tier tournaments with a single dashboard. Reduce administrative overhead and focus on the sport.",
      backgroundImage: league,
      buttonText: "Learn More",
      buttonRoute: "/features/league-manager",
    },
    {
      id: "ai-highlights",
      title: "AI Highlights",
      description:
        "Experience cricket like never before with AI highlights. Our AI highlights every moment in the field, capturing key plays, stunning deliveries and game changing shots in real time.",
      backgroundImage: feature2Bg,
      buttonText: "Learn More",
      buttonRoute: "/features/ai-highlights",
    },
    {
      id: "live-streaming",
      title: "Live Streaming",
      description:
        "Stay tuned to our live cricket streaming for real time action, expert analysis, and in depth insights on every ball bowled",
      backgroundImage: feature3Bg,
      buttonText: "Learn More",
      buttonRoute: "/features/live-streaming",
    },
    {
      id: "effortless-scoring",
      title: "Effortless Cricket Scoring",
      description:
        "A clutter-free, intuitive scoring engine designed for the heat of the match. Record extras, wickets, and milestones with zero lag, ensuring the digital scorecard stays in sync with the stadium.",
      backgroundImage: feature4Bg,
      buttonText: "Learn More",
      buttonRoute: "/features/scoring",
    },
  ],
};
